import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutObjection extends Layout {
    sourceObjection: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxResponseScript: Textbox;
}
